import React from 'react';
import { rootStore } from './index';

export const StoreContext = React.createContext({
  rootStore,
});

export const useStores = () => React.useContext(StoreContext);
